// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"72":"a3ed6253","798":"6b5458f0"}[chunkId] + ".js";
};